import React from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import {parseQueryString} from '../../../utils/url'
import {RouterProviderProps} from '../types'
import {useRouterFunctionsWithBail} from '../utils/migration'
import {RouterContext, type RouterContextProps} from './RouterContext'

/**
 * This router provider will be used as a temporary abstraction
 * to facilitate our migration to Next.js.
 * This should be deleted as we fully migrate the app to the framework.
 *
 * Use this provider in apps that use react-router routing
 * @param props - The props for the router provider
 * @param props.children - The children component to render
 * @param props.isCrossingRouters - Whether the router is crossing between different router contexts
 */
export const RouterProvider = ({
  children,
  isCrossingRouters
}: RouterProviderProps) => {
  const history = useHistory()
  const {pathname, search} = useLocation()

  const getQueryParams = () => parseQueryString(history.location.search)

  // TODO: consider removing this wrapping in sc-147995
  const {push, replace} = useRouterFunctionsWithBail(history, isCrossingRouters)

  return (
    <RouterContext.Provider
      value={{
        push: push as RouterContextProps['push'],
        replace: replace as RouterContextProps['replace'],
        goBack: history.goBack,
        getQueryParams,
        pathname,
        queryString: search,
        routerType: 'react-router'
      }}
    >
      {children}
    </RouterContext.Provider>
  )
}
